import flatpickr from "flatpickr"
import "flatpickr/dist/l10n/fr.js" // { French } from
require('flatpickr/dist/themes/light.css')
import ApplicationController from './application_controller'

export default class FlatPickrController extends ApplicationController {

  static targets = [
    "flatpickrInput"
  ]

  connect() {
    this.picker = flatpickr(this.element, {
      locale: this.element.dataset.locale,
      allowInput: true,
      altInput: true,
      altFormat: this.element.dataset.format,
      /*
      onClose: function (e) {
        if (isBlank(this.picker._input.value))
          this.flatpickrInputTarget.value = ""
      }.bind(this)
      */
    })
    if (this.element.dataset.listenevents === "true") {
      this.evtL1 = this.evtDateChange.bind(this)
      document.addEventListener('@flat-picker#changeDate', this.evtL1, false)
    }
  }

  disconnect() {
    this.picker.destroy()
    if (this.element.dataset.listenevents === "true") {
      document.removeEventListener('@flat-picker#changeDate', this.evtL1, false)
    }
  }

  evtDateChange(e) {
    this.picker.setDate(e.detail)
  }

}